// src/pages/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import styles from './LoginPage.module.css';

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !password) return;
        setLoading(true);
        try {
            await login(email, password);
            navigate('/');
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Invalid Credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.page}>
            {/* Background pattern */}
            <div className={styles.bg}>
                <div className={styles.bgGlow} />
                <div className={styles.bgGrid} />
            </div>

            <div className={styles.container}>
                {/* Logo */}
                <div className={styles.logo}>
                    <div className={styles.logoMark}>
                        <span>G</span>
                    </div>
                    <div className={styles.logoText}>
                        <span className={styles.logoName}>GAAF<em>rfid</em></span>
                        <span className={styles.logoSub}>Inventory Management Platform</span>
                    </div>
                </div>

                {/* Card */}
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <h1>Welcome back</h1>
                        <p>Sign In to your Dashboard</p>
                    </div>

                    <form className={styles.form} onSubmit={handleSubmit}>
                        <div className={styles.field}>
                            <label htmlFor="email">Email Address</label>
                            <input
                                id="email"
                                type="email"
                                placeholder="you@yourcompany.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoComplete="email"
                                autoFocus
                            />
                        </div>

                        <div className={styles.field}>
                            <label htmlFor="password">Password</label>
                            <input
                                id="password"
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                        </div>

                        <button
                            type="submit"
                            className={styles.submitBtn}
                            disabled={loading}
                        >
                            {loading ? (
                                <><span className={styles.spinner} /> Signing in…</>
                            ) : (
                                'Sign In →'
                            )}
                        </button>
                    </form>
                </div>

                <p className={styles.footer}>
                    GAAFrfid · RFID Inventory Platform · &copy; {new Date().getFullYear()}
                </p>
            </div>
        </div>
    );
}
